import { Logger } from "./logger"

class SessionTimeState {
    private isTimerStarted: boolean = false
    private videoStartTimestamp: number = 0
    private totalVideoSessionTime: number = 0

    startTimer() {
        if (this.isTimerStarted) {
            return
        }
        this.videoStartTimestamp = Date.now()
        this.isTimerStarted = true
        Logger.printLog('info',
            `SessionTimeState:`,
            `startTimer: ${new Date(this.videoStartTimestamp).toLocaleTimeString()},
            totalVideoSessionTime: ${this.totalVideoSessionTime}`)
    }

    updateTimer(state=''): null | { stopTime: any, elapsed: any } {
        if (!this.isTimerStarted) {
            return null
        }
        const stopTime = Date.now()
        const elapsed = Math.floor((stopTime - this.videoStartTimestamp) / 1000)
        //important to reset the videoStartTime to calculate the next stop when the ad starts to play.
        this.videoStartTimestamp = stopTime
        this.totalVideoSessionTime += elapsed
        if(state == 'update') {            
            Logger.printLog('info',
            `SessionTimeState:`,
            `updateTimer: ${new Date(stopTime).toLocaleTimeString()}, 
            totalVideoSessionTime: ${this.totalVideoSessionTime},
            elapsed in ms: ${elapsed} `)
        }
        return {
            stopTime,
            elapsed
        }
    }

    stopTimer() {
        if (!this.isTimerStarted) {
            return
        }
        const { stopTime, elapsed } = this.updateTimer() as { stopTime: any, elapsed: any }
        this.isTimerStarted = false
        Logger.printLog('info',
            `SessionTimeState:`,
            `stopTimer: ${new Date(stopTime).toLocaleTimeString()}, 
            totalVideoSessionTime: ${this.totalVideoSessionTime},
            elapsed in ms: ${elapsed} `)
    }

    getSessionTime() {
        return this.totalVideoSessionTime;
    }

    getSessionTimeInMS() {
        return this.totalVideoSessionTime * 1000;
    }

    resetSessionTime() {
        this.totalVideoSessionTime = 0
    }
}

export default SessionTimeState
